import type { IInputFilterDropdown } from '../../../../types/data_table';

import { Dropdown } from '../../../Dropdown';
import { DropdownButton } from '../../../Dropdown/DropdownButton';

/**
 * A text or phone filter shown as its own always-visible control.
 *
 * Used when it is the table's only filter: there is nothing to choose between,
 * so hiding it behind the "+" menu would only add a click. It doubles as its
 * own chip, showing the applied value on the button.
 */
export const InputFilterDropdown = ({
  filter,
  appliedValue,
  disabled,
  renderMenu,
  onApply,
  onClear,
}: IInputFilterDropdown) => (
  <Dropdown width="fit-content">
    <DropdownButton
      label={filter.label}
      text={appliedValue}
      hideDropdownChevron={!appliedValue}
      disabled={disabled}
      onClearHandler={appliedValue ? onClear : undefined}
    />
    {renderMenu(filter, onApply)}
  </Dropdown>
);
